import { HttpErrorResponse } from "@angular/common/http";

import { Client } from "@models/client.model";
import { createReducer, on } from "@ngrx/store";

import {
  CLIENT_ACTION_FAILURE,
  SET_CLIENT,
  SET_CLIENT_LOADING,
} from "./client.actions";

export interface ClientState {
  clientLoading: boolean;
  client: Client;
  error: HttpErrorResponse | null;
}

const initialState: ClientState = {
  clientLoading: false,
  client: new Client(),
  error: null,
};

export const CLIENT_REDUCER = createReducer(
  initialState,
  on(CLIENT_ACTION_FAILURE, (state, action): ClientState => {
    return {
      ...state,
      error: action.error,
    };
  }),
  on(
    SET_CLIENT_LOADING,
    (state: ClientState, action: { loading: boolean }): ClientState => {
      return {
        ...state,
        clientLoading: action.loading,
      };
    }
  ),

  on(
    SET_CLIENT,
    (state: ClientState, action: { data: Client }): ClientState => {
      return {
        ...state,
        client: action.data,
      };
    }
  )
);
